@let savedSearchesInfo = savedSearchesInfo$ | async;
@let activeSavedSearchId = activeSavedSearchId$ | async;

<div class="rpc-saved-search-list" (swipeup)="onExpandPanel()" data-mc-options='{ "touchAction": "pan-y" }'>

    <div class="rpc-saved-search-list-header">

        <div class="rpc-saved-search-list-header-title-wrap">

            <div class="rpc-saved-search-list-header-title rpc-title-font">
                {{'SAVED_SEARCH_LIST.TITLES.SAVED_SEARCHES' | translate}}
            </div>

            <rpc-button class="rpc-saved-search-list-header-close" [iconName]="'cross'" (clicked)="onClose()"
                [title]="'SAVED_SEARCH_LIST.TITLES.CLOSE'">
            </rpc-button>

        </div>

    </div>

    <div class="rpc-saved-search-list-body">

        @for (savedSearchInfo of savedSearchesInfo; track $index) {

        <saved-search-info class="rpc-saved-search-list-item" [savedSearch]="savedSearchInfo"
            [isEditable]="savedSearchInfo.isEditable" [isActive]="savedSearchInfo.id === activeSavedSearchId"
            (clicked)="onSavedSearchSelected(savedSearchInfo.id)" (edit)="onEditSavedSearch(savedSearchInfo.id)">
        </saved-search-info>

        @if (!$last) { <div class="rpc-divider rpc-divider--horizontal rpc-saved-search-list-divider">
        </div>
        }

        }

    </div>

</div>